

















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { isDocumentFile, isTextFile } from "@/lib/fileHelpers";
import { AttachmentFile } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import DocumentPreview from "@/components/DocumentPreview";
import ImagePreview from "@/components/ImagePreview";

export default defineComponent({
  name: "MediaPreview",
  components: { BaseIcon, ImagePreview, LoadingThumbnail },
  props: {
    file: { type: Object as PropType<AttachmentFile | FileData>, required: true },
    allowPublicFiles: { type: Boolean, default: true },
    publicAccess: { type: Boolean, default: false },
    progress: { type: Number, default: 100 },
  },
  setup(props) {
    const src = computed(() => (isTextFile(props.file) || isDocumentFile(props.file) ? "" : props.file.src));

    const component = computed(() =>
      isTextFile(props.file) || isDocumentFile(props.file) ? DocumentPreview : ImagePreview
    );

    return { src, component };
  },
});
